<template>
  <div class="">
    <!-- Content Header (Page header) -->
    <div class="">

      <section class="content">
        <div class="container-fluid">
          <!-- Main row -->
          <div class="row">
            <section class="col-lg-12 connectedSortable table-area mt-3 pr-0 pl-0 mb-3">
              <div class="card">
                <div class="card-body  table-responsive table-head">
                  <div class="row bor-bot pb-3">
                    <div class="col-md-8 pl-0">
                      <h1 class="m-0 text-dark pt-2">Member Type</h1>
                    </div>
                      <div class="col-md-4">
                        <div class="text-right pb-3">
                          <ol class="breadcrumb float-sm-right">
                          <li class="breadcrumb-item"><a href="/admin/dashboard">Home</a></li>
                          <li class="breadcrumb-item"><Breadcrumbs/></li>
                          </ol>
                        </div>
                      </div>


                  </div>                  
                  <div class="row">
                    <div class="col-lg-8 mr-0 pr-0">
                      <div class="mt-3">
                      <b-form inline>
                        <label class="mr-sm-2 font-weight-normal">Show</label>
                        <b-form-select
                          id="inline-form-custom-select-pref"
                          class="mb-2 mr-sm-2 mb-sm-0"
                          v-model="perPage"
                          :options="viewEntryOptions"
                          size="sm"
                        ></b-form-select
                        >entries
                      </b-form>
                    </div>
                    </div>
                    <div class="col-lg-4  text-right pr-0">
                      <div class="card-text d-flex align-items-center float-right">
                        <div class="mt-3 ml-3">
                      <b-input-group size="sm">
                        <b-form-input
                          id="filter-input"
                          v-model="filter"
                          type="search"
                          placeholder="Type to search..."
                        ></b-form-input>
                      </b-input-group>
                        </div>
                      <div class="mt-3 ml-3">
<!--                      <b-button-->
<!--                      class="darkblubtn"-->
<!--                      variant="outline-primary"-->
<!--                      @click="addRow($event.target)"-->
<!--                      >Add Member Type</b-button-->
<!--                    >-->
                      </div>
                      </div>
                      

                    </div>
                  </div>
                  
                  <b-table
                    ref="member-typeTable"
                    id="member-type-table"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="items"
                    :fields="fields"
                    :busy="!loaded"
                    class="mt-3"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    no-sort-reset
                    sort-icon-left
                    hover
                    show-empty
                  >
                    <template #cell(index)="row">
                      {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(actions)="row">
                      <div class="text-center py-0 align-middle">
                        <div class="btn-group btn-group-sm">
                          <button
                            class="btn btn-primary"
                            title="Edit Reporting Group"
                            @click="editReportingGroup(row.item, $event.target)"
                          >
                            <i class="fas fa-pencil-alt"></i>
                          </button>
                        </div>
                      </div>
                    </template>
                    <template #empty="scope">
                      <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                  <br />
                  <b-pagination
                    v-if="loaded"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    prev-text="Previous"
                    next-text="Next"
                    aria-controls="member-type-table"
                     class="float-right custom-color"
                    hide-goto-end-buttons
                  ></b-pagination>
                  <!-- Info modal -->
                  <b-modal
                    :id="infoModal.id"
                    :title="infoModal.title"
                    size="lg"
                    ok-only
                    @hide="resetInfoModal"
                  >
                    <dl class="row">
                      <dt class="col-sm-2">Name</dt>
                      <dd class="col-sm-10">{{ infoModal.content.name }}</dd>

                      <dt class="col-sm-2">Code</dt>
                      <dd class="col-sm-10">
                        {{ infoModal.content.description }}
                      </dd>
                    </dl>
                  </b-modal>
                  <!-- Edit modal -->
                  <b-modal
                    id="edit-modal"
                    :title="editModal.title"
                    size="lg"
                    ref="modal"
                    @ok="handleOk"
                    @hide="resetEditModal"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <form ref="form" @submit.stop.prevent="handleSubmit">
                          <div>
                            <label class="pt-4" for="feedback-name">Name</label>
                            <b-form-input
                              @keydown="errors.clear('name')"
                              v-model="editModal.content.name"
                              :class="errors.has('name') ? 'is-invalid' : ''"
                              id="feedback-name"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="!errors.has('name')"
                            >
                              {{ errors.get("name") }}</b-form-invalid-feedback
                            >
                          </div>

                          <div class="pt-2">
                            <label class="pt-4" for="feedback-description"
                              >Description</label
                            >
                            <b-form-input
                              @keydown="errors.clear('description')"
                              v-model="editModal.content.description"
                              :class="
                                errors.has('description') ? 'is-invalid' : ''
                              "
                              id="feedback-product_description"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="!errors.has('description')"
                            >
                              {{
                                errors.get("description")
                              }}</b-form-invalid-feedback
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </b-modal>
                  <b-modal
                    id="reporting-group-modal"
                    ref="reporting-group-modal"
                    title="Update Reporting Group"
                    ok-title="Update"
                    :ok-disabled="savingReportingGroup"
                    :cancel-disabled="savingReportingGroup"
                    @ok="handleReportingGroupOk"
                    @hide="resetReportingGroupModal"
                  >
                    <dl class="row mb-3">
                      <dt class="col-sm-4">Member Type</dt>
                      <dd class="col-sm-8">
                        {{ reportingGroupModal.membershipName }}
                      </dd>
                    </dl>
                    <label for="reporting-group-select">Reporting Group</label>
                    <b-form-select
                      id="reporting-group-select"
                      v-model="reportingGroupModal.reporting_group"
                      :options="reportingGroupOptions"
                      :disabled="savingReportingGroup"
                    >
                      <template #first>
                        <b-form-select-option :value="null"
                          >Select</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                    <b-spinner
                      v-if="loadingReportingGroupOptions"
                      small
                      class="mt-2"
                    ></b-spinner>
                    <div
                      v-if="reportingGroupModal.error"
                      class="text-danger text-sm mt-2"
                    >
                      {{ reportingGroupModal.error }}
                    </div>
                  </b-modal>
                </div>
              </div>
            </section>
          </div>
          <!-- /.row (main row) -->
        </div>
        <!-- /.container-fluid -->
      </section>
    </div>
    <!-- /.content -->

  </div>
</template>

<script>
import axios from "axios";
import Errors from "../../Errors.js";
import moment from "moment";
// import DatePick from "vue-date-pick";

let cachedData = [];

export default {
  name: "member-type",
  components: {  },

  data() {
    return {
      loaded: false,
      perPage: 10,
      currentPage: 1,
      sortBy: null,
      sortDesc: false,
      errors: new Errors(),
      fields: [
        {
          key: "index",
          label: "S.No",
          sortable: false,
          class: "text-nowrap",
          thStyle: { width: "8%" },
        },
        {
          key: "name",
          label: "Member Type",
          sortable: true,
          class: "text-nowrap",
          thStyle: { width: "34%" },
        },
        {
          key: "reporting_group",
          label: "Reporting Group",
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: this.reportingGroupLabel,
          class: "text-nowrap",
          thStyle: { width: "34%" },
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: { width: "24%" },
        },
      ],
      items: [],
      viewEntryOptions: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 20, text: "20" },
      ],
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      editModal: {
        editing: true,
        id: "edit-modal",
        title: "",
        content: "",
      },
      reportingGroupOptions: [],
      loadingReportingGroupOptions: false,
      savingReportingGroup: false,
      reportingGroupModal: {
        id: null,
        membershipName: "",
        reporting_group: null,
        error: "",
      },
    };
  },

  filters: {
    productStatus(value) {
      return value ? "Active" : "Inactive";
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    },
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    mapMemberships(memberships) {
      return memberships || [];
    },
    reportingGroupLabel(group) {
      if (group === null || group === undefined || group === "") {
        return "N/A";
      }
      return (typeof group === "object" ? group.name : group) || "N/A";
    },
    reportingGroupValue(group) {
      if (group === null || group === undefined || group === "") {
        return null;
      }
      return typeof group === "object" ? group.id : group;
    },
    loadMemberships() {
      this.loaded = false;
      axios
        .get(process.env.VUE_APP_URL + "api/get_memberships", {
          headers: this.adminHeaders,
        })
        .then((response) => {
          cachedData = response.data.data || [];
          this.items = this.mapMemberships(cachedData);
          this.loaded = true;
        })
        .catch((error) => {
          this.errors = error.response && error.response.data;
          this.loaded = true;
        });
    },
    getReportingGroupOptions() {
      this.loadingReportingGroupOptions = true;
      axios
        .get(
          process.env.VUE_APP_URL + "api/member_types/reporting-group-options",
          { headers: this.adminHeaders }
        )
        .then((response) => {
          const payload = response.data || {};
          const raw = Array.isArray(payload)
            ? payload
            : payload.data ||
              payload.reporting_groups ||
              payload.reportingGroups ||
              payload.options ||
              [];
          this.reportingGroupOptions = Object.values(raw).map((option) => {
            if (option !== null && typeof option === "object") {
              const value =
                option.id !== undefined
                  ? option.id
                  : option.value !== undefined
                  ? option.value
                  : option.reporting_group;
              return { value: value, text: option.name || option.text || value };
            }
            return { value: option, text: option };
          });
        })
        .catch(() => {
          this.reportingGroupModal.error =
            "Unable to load reporting group options.";
        })
        .finally(() => {
          this.loadingReportingGroupOptions = false;
        });
    },
    editReportingGroup(item, button) {
      this.reportingGroupModal.id = item.id;
      this.reportingGroupModal.membershipName = item.name;
      this.reportingGroupModal.reporting_group = this.reportingGroupValue(
        item.reporting_group
      );
      this.reportingGroupModal.error = "";
      if (!this.reportingGroupOptions.length) {
        this.getReportingGroupOptions();
      }
      this.$root.$emit("bv::show::modal", "reporting-group-modal", button);
    },
    handleReportingGroupOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.savingReportingGroup = true;
      const membershipId = this.reportingGroupModal.id;
      const reportingGroup = this.reportingGroupValue(
        this.reportingGroupModal.reporting_group
      );
      axios
        .post(
          process.env.VUE_APP_URL +
            "api/member_types/update-reporting-group/" +
            membershipId,
          {
            reporting_group: reportingGroup,
            reporting_group_id: reportingGroup,
          },
          { headers: this.adminHeaders }
        )
        .then((response) => {
          this.loadMemberships();
          this.$bvModal.hide("reporting-group-modal");
          this.$bvToast.toast(
            (response.data && response.data.message) ||
              "Reporting group updated successfully",
            { variant: "success", solid: true }
          );
        })
        .catch((error) => {
          const data = error.response && error.response.data;
          this.reportingGroupModal.error =
            (data && (data.message || data.errors)) ||
            "Unable to update the reporting group.";
        })
        .finally(() => {
          this.savingReportingGroup = false;
        });
    },
    resetReportingGroupModal() {
      this.reportingGroupModal.id = null;
      this.reportingGroupModal.membershipName = "";
      this.reportingGroupModal.reporting_group = null;
      this.reportingGroupModal.error = "";
    },
    addRow(button) {
      (this.editModal.editing = false),
        (this.editModal.title = "Add New Member Type");
      let id = localStorage.getItem("id");
      this.editModal.content = {
        name: "",
        code: "",
        organization_id: 1,
        updated_by: 1,
      };
      this.$root.$emit("bv::show::modal", "edit-modal", button);
    },
    viewRow(item, index, button) {
      this.infoModal.title = item.name;
      this.infoModal.content = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    editRow(item, button) {
      (this.editModal.editing = true),
        (this.editModal.title = "Update " + item.name);
      this.editModal.content = item;
      this.$root.$emit("bv::show::modal", "edit-modal", button);
    },
    deleteRow(id) {
      confirm("Are you sure to delete this item?");
      axios
        .delete(process.env.VUE_APP_URL + "api/member_types/delete/" + id)
        .then((response) => {
          alert("Member type deleted!");
          this.resetEditModal();
        })
        .catch((error) => {
          (error) => (this.errors = error.response.data);
        });
      return false;
    },

    //Modals
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    resetEditModal() {
      this.errors.clear();
      this.loadMemberships();
    },

    // Submitting
    onFail(errors) {
      this.errors.record(errors);
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      let url = process.env.VUE_APP_URL + "api/member_types";
      let requestType = "post";

      if (this.editModal.editing) {
        url = process.env.VUE_APP_URL + "api/member_types/update/" + this.editModal.content.id;
        requestType = "patch";
      }

      this.handleSubmit(requestType, url)
        .then(() => {
          this.$nextTick(() => {
            var message = this.editModal.editing ? "saved" : "created";
            alert("Member type has been " + message + ".");
            this.$bvModal.hide("edit-modal");
          });
        })
        .catch(() => false);
    },

    handleSubmit(requestType, url) {
      return new Promise((resolve, reject) => {
        axios[requestType](url, this.editModal.content)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            this.onFail(error.response.data.errors);
            reject(error.response.data);
          });
      });
    },
    isFutureDate(date) {
      const currentDate = new Date();
      return date > currentDate;
    },
  },

  created() {
    this.loadMemberships();
  },

  computed: {
    rows() {
      return this.items.length;
    },
  },
};
</script>

<style>
/* Widen the gap between the left-anchored sort icon and the column label. */
#member-type-table thead th.b-table-sort-icon-left {
  padding-left: calc(0.75rem + 1.6em) !important;
}
</style>